import React, { useEffect,  useRef } from 'react';
import { createUseStyles } from 'react-jss';
import MzInputText from '../MzInputText';
import { InputText } from 'primereact/inputtext';


import { useFormikContext } from "formik";
import { useField } from 'formik';
import { classNames } from 'primereact/utils';
import MzErrorMessage from './MzErrorMessage';

function MzFormInputText({ name, label, isTouched }) {
    const [field] = useField(name);
	const inputRef = useRef(null);
    const st = styles();
    const { setFieldTouched, handleChange, errors, touched } = useFormikContext();

    useEffect(() => {
       if(isTouched){
		    inputRef.current.focus();
	   }
    }, []);

    return (
        <div className="field  w-full">
            <label>{label}</label>
            <span className=" w-full">
                <InputText ref={inputRef}  id={name} name={name} value={field.value} onChange={handleChange} autoFocus className={"w-full "} />
            </span>
            <MzErrorMessage error={errors[name]} visible={touched[name]} />
        </div>
    );
}

const styles = createUseStyles({
    container: {}
});

export default MzFormInputText;